<template>
  <div class="border-login">
    <div
      class="login"
      style="
        margin: 0 auto;
        max-width: 1000px;
        border-radius: 3px;
        padding-top: 50px;
        padding: 20px;
        height: 100%;
        min-height: calc(100vh - 50px);
      "
    >
      <a-card style="min-width: 400px;">
        <div class="logo-ict">
          <!-- <img src="@/assets/logo-ict.png" style="margin-bottom: 20px;" /> -->
          <p class="ant-descriptions-title">Đăng Nhập</p>
        </div>

        <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules">
          <a-form-model-item has-feedback prop="username">
            <a-input v-model="ruleForm.username" placeholder="Tên đăng nhập">
              <a-icon
                slot="prefix"
                type="user"
                style="color: rgba(0, 0, 0, 0.25);"
              />
            </a-input>
          </a-form-model-item>

          <a-form-model-item has-feedback prop="password">
            <a-input
              v-model="ruleForm.password"
              type="password"
              placeholder="Mật khẩu"
              @pressEnter="submitForm('ruleForm')"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color: rgba(0, 0, 0, 0.25);"
              />
            </a-input>
          </a-form-model-item>

          <a-form-model-item>
            <a-button
              :loading="loadingBtn"
              type="primary"
              @click="submitForm('ruleForm')"
            >
              Đăng Nhập
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-card>
    </div>
  </div>
</template>
<script>
import queryMutation from "./data/postData";

// Name of the localStorage item
const AUTH_TOKEN = process.env.VUE_APP_AUTH_TOKEN_NAME || "apollo-token";
const CURRENT_USER = process.env.VUE_APP_CURRENT_USER_NAME || "currentUser";

export default {
  data() {
    return {
      users: [],
      ruleForm: {
        username: "",
        password: "",
      },
      rules: {
        password: [
          {
            required: true,
            message: "Mật khẩu không được bỏ trống",
            trigger: "change",
          },
          {
            min: 8,
            max: 60,
            message: "Số kí tự mật khẩu phải từ 8 đến 60",
            trigger: "change",
          },
        ],

        username: [
          {
            required: true,
            message: "Tên đăng nhập không được bỏ trống",
            trigger: "change",
          },
          {
            min: 3,
            message: "Tên đăng nhập ít nhất 4 kí tự",
            trigger: "change",
          },
        ],
      },
      layout: {},
      loadingBtn: false,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.signIn();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    signIn() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: queryMutation.signIn,
          variables: {
            ...this.ruleForm,
            remember: true,
          },
        })
        .then((data) => {
          if (data?.data?.signIn?.token && data.data.signIn.user) {
            localStorage.setItem(AUTH_TOKEN, data.data.signIn.token);
            localStorage.setItem(
              CURRENT_USER,
              JSON.stringify(data.data.signIn.user)
            );
            this.loadingBtn = false;
            this.$router.push("/");
          }
        })
        .catch((error) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Sai tài khoản hoặc mật khẩu vui lòng nhập lại !",
          });
          console.log("Đăng nhập thất bại", error);
        });
    },
  },
};
</script>
<style scoped>
.border-login {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo-ict {
  /* text-align: center; */
}
</style>
